import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-otagentseting',
  templateUrl: './otagentseting.component.html',
  styleUrls: ['./otagentseting.component.css']
})

export class OtagentsetingComponent implements OnInit {
  constructor(
    public httpClient: HttpClient,
    private  route: ActivatedRoute,
  ){}


  search_model:string = '';
  now:string = '3';
  subnow:string = '1';
  vid:string = '-1';

  sort_obj:any = {column:'last_round_diamond',sort:'0'}
  menu_list:menulist = [/*{id:'1',name:'薪資級距'},{id:'2',name:'獎金級距'},*/{id:'3',name:'獎金設定'},{id:'4',name:'匯率級距'}]
  vendor_list:menulist = []
  data:any=[];
  edit_data:any={id:-1,lv:1,percent:50,points:0,diamond_start:0,diamond_end:100000,diamond:100000,status:1,points_type:this.now == '1'?2:1}

  loading:boolean=true;
  all_check:boolean=true;
  pageobj:page = {page:0,count:30,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  
  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('vid')){
      this.vid = this.route.snapshot.paramMap.get('vid');
    }
    if(this.route.snapshot.paramMap.get('mid')){
      this.now = this.route.snapshot.paramMap.get('mid');
    }
    this.choose(this.now)
    this.init_list();
  }


  save(){
    console.log(this.edit_data);
    if(this.edit_data.points.length==0||this.edit_data.diamond_start.length==0||this.edit_data.diamond_end.length==0||this.edit_data.lv.length==0){
      alert('請確保欄位都有填寫');
    }else if(this.edit_data.diamond_start*1>=this.edit_data.diamond_end*1 && this.now !='3'){
      console.log(this.edit_data.diamond_start,this.edit_data.diamond_end);
      alert('請確保最大值大於最小值');
      this.init_list();
    }else{
      this.loading = true;
      const body = {data:this.edit_data,type:this.now,vid:this.vid};
      this.httpClient.post<any>("/update_vendor_ranking.php",body).subscribe(res => {
        this.loading = false;
        if(res.status){
          alert('儲存成功');
        }else{
          alert(res.message);
        }
        console.log('save',res);
        this.init_list();
      });
    }
  }

  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    vid:this.vid,
    type:this.now,
    sort_obj:this.sort_obj,
    search_model:this.search_model,
    ottype:1
    };
    this.httpClient.post<any>("/get_vendor_ranking.php",body).subscribe(res => {
      this.loading = false;
      this.edit_data.diamond_start = res.min //抓最小
      if(res.min!=1){//代表已經有初始資料 那麼最大值 直接由 經紀填寫
        this.edit_data.diamond_end = '';
      }
      if(res.status){
        this.data = res.data
        this.vendor_list = res.vendor_list;
        this.pageobj.total_count = res.total_count
        if(this.vid=='-1' && res.data.length>0){
          this.vid = res.data[0].vid;
        }else if(this.vid=='-1' ){
          if(res.vendor_list.length==0){
            this.vid ="-1";
          }else{
            this.vid = res.vendor_list[0].id;
          }
         
        }
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        this.vendor_list = [];

      }
      console.log(res);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  choose(value:string){
    this.now = value;
    const percent = this.now == '1'?50:(this.now == '4'?60:0);
    const points = this.now == '1'?0:2000;
    this.edit_data = {id:-1,lv:1,percent:percent,points:points,diamond_start:0,diamond_end:100000,diamond:100000,status:1,points_type:this.now == '1'?2:1}
    this.pageobj.page = 0;
    this.init_list();
  }

  generateIdArray(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  }
}
